import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class WilliamsRTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      origin: originProp,
      className,
      fontFamily,
      fontSize,
      labelFill,
      valueFill,
      yAccessor,
      yDisplayFormat,
      displayValuesFor: displayValuesForProp,
      onClick,
    } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const currentItem = displayValuesForProp(this.props, moreProps);
    const value = currentItem ? yAccessor(currentItem) : undefined;
    const displayValue =
      value !== undefined && value !== null ? yDisplayFormat(value) : "n/a";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-williams-r"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Williams %R: </ToolTipTSpanLabel>
          <tspan fill={valueFill}>{displayValue}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

WilliamsRTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  valueFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  yDisplayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
};

WilliamsRTooltip.defaultProps = {
  origin: [0, 10],
  className: "react-stockcharts-tooltip react-stockcharts-williamsr-tooltip",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 11,
  labelFill: "#4682B4",
  valueFill: "#000000",
  yDisplayFormat: format(".2f"),
  displayValuesFor,
  onClick: undefined,
};

export default WilliamsRTooltip;
